import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { LoadSpinner } from "../../components/LoadSpinner";

export const TextContent = observer((props) => {
  const [text, setText] = useState("");
  const [contentLoaded, setContentLoaded] = useState(false);
  const { settings, environment, replaceTags, checkHeights, orders } = props;
  const { content, hidden } = settings;
  const checkHeightsRef = useRef(null);
  const checkHeightsIntervalRef = useRef(null);
  const intervalCountRef = useRef(0);
  useEffect(() => {
    // setText(content[environment.lang]);
    // replaceTags(content[environment.lang]).then((replacedText) => setText(replacedText));
    if (checkHeightsIntervalRef.current == null) {
      checkHeightsIntervalRef.current = setInterval(() => {
        if (checkHeightsRef.current) {
          checkHeightsRef.current();
          intervalCountRef.current += 1;
        }
        if (intervalCountRef.current > 20) {
          if (checkHeightsIntervalRef.current) {
            clearInterval(checkHeightsIntervalRef.current);
            checkHeightsIntervalRef.current = null;
          }
        }
      }, 1000);
    }
    return () => {
      if (checkHeightsIntervalRef.current) {
        clearInterval(checkHeightsIntervalRef.current);
        checkHeightsIntervalRef.current = null;
      }
    }
  }, []);
  useEffect(() => {
    checkHeightsRef.current = checkHeights;
  })
  useEffect(() => {
    replaceTags(content[environment.lang]).then((replacedText) => {
      setText(replacedText)
      setContentLoaded(true);
      setTimeout(checkHeights, 50);
    });
  }, [content, environment.lang, orders]);

  if (hidden) return <div style={{ height: "1px" }}></div>;
  if (contentLoaded) {
    return <div style={{ width: "100%" }} dangerouslySetInnerHTML={{ __html: text }} />;
  }
  else {
    return <LoadSpinner isModule={true} />
  }
});
